import React from 'react';
import Link from '../Link/Link';

var OnBoardingSkip = function OnBoardingSkip(props) {
  var onSkip = props.onSkip,
      skipText = props.skipText;
  return /*#__PURE__*/React.createElement(Link, {
    onClick: onSkip,
    dataAid: "skip-btn"
  }, skipText, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "13",
    viewBox: "0 0 13 13"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.12 6.714l.02.02-5.811 5.813-.62-.62 5.386-5.387-5.213-5.213.62-.62 5.812 5.812-.194.195z",
    opacity: ".7"
  })));
};

export default OnBoardingSkip;